import React, { useState } from "react";
import "./Homepage_services_card.css";
import { Link } from "react-router-dom";

function Homepage_services_card({ imgSrc, cradHeadting }) {
  // State to manage if the card is hovered
  const [isHovered, setIsHovered] = useState(false);

  // Function to handle mouse enter event
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  // Function to handle mouse leave event
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <section
        className="Homepage_services_card"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="Homepage_services_card_holder">
          <div className="img-box-holder">
            <div className="img-holder">
              <img
                className="Homepage_services_card_img"
                src={process.env.PUBLIC_URL + imgSrc}
              />
              {/* Conditionally add the 'rotate-center' class based on hover state */}
              <div
                className={` box-color ${
                  isHovered
                    ? "white-box-color rotate-center"
                    : "opposite-rotate-center "
                }`}
              ></div>
            </div>
          </div>
          <div className="content-holder">
            <h3>{cradHeadting}</h3>
          </div>
          <div className="span-holder">
            <Link to={"/services"}>
              <p>KNOW MORE</p>
            </Link>
          </div>
          <div className="bg-color-holder"></div>
        </div>
      </section>
    </>
  );
}

export default Homepage_services_card;
